import icestoneConfig from "../src/icestone-config.json"

const getConfig = () => {
  return icestoneConfig;
}

export const AppConfig = getConfig();